import { Grid } from "@material-ui/core";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
} from "App/constants";
import {
  convertToValidPrice,
  defaultToastError,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import React, { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";

export default function ModalDetail({ setShowModal }) {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const {
    formDetailWork,
    setFormDetailWork,
    setListDetailWork,
    listDetailWork,
  } = useContext(FormContext);

  const handleChange = (text) => (e) => {
    setFormDetailWork({
      ...formDetailWork,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (isNull(formDetailWork.status)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Status tidak boleh kosong !");
    } else {
      try {
        //  Buat Baru
        if (formDetailWork.onCreate) {
          const maxDetailWork = Math.max(...listDetailWork.map((o) => o.index));
          setListDetailWork([
            ...listDetailWork,
            {
            index: isNaN(maxDetailWork) ? 0 : maxDetailWork + 1,
            status: formDetailWork?.status,
            pembelian: formDetailWork.pembelian,
            harga: convertToValidPrice(formDetailWork?.harga)
          }
          ]
            
          );
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        } else {
          // Update
          const detailWork = listDetailWork;
          const checkList = detailWork.filter(
            (e) => e.index !== formDetailWork.index
          );
          checkList.push({
            index: formDetailWork?.index,
            status: formDetailWork?.status,
            pembelian: formDetailWork.pembelian,
            harga: convertToValidPrice(formDetailWork?.harga),
          });
          setListDetailWork(checkList);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        // End Tanpa ID
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  return (
    <Modal
      title={
        formDetailWork.onCreate
          ? "Tambah Detail Pengerjaan"
          : "Ubah Detail Pengerjaan"
      }
      show={setShowModal}
      width="80%"
    >
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="index"
            id="index"
            readOnly={true}
            value={formDetailWork?.index}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name="status"
              label="KETERANGAN STATUS PENGERJAAN"
              id="status"
              value={formDetailWork?.status}
              onChange={handleChange("status")}
              placeholder="Contoh : Ganti suku cadang"
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name="pembelian"
              label="PEMBELIAN"
              id="pembelian"
              value={formDetailWork?.pembelian}
              onChange={handleChange("pembelian")}
              placeholder="Contoh : Charger"
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name="harga"
              label="HARGA"
              id="harga"
              placeholder="0"
              value={formDetailWork.harga}
              onInput={(e) => {
                let val = e.target.value;
                setFormDetailWork({
                  ...formDetailWork,
                  harga: formatRupiah(val),
                });
              }}
              withButtonLeft={true}
            >
              <button
                type={"button"}
                onClick={null}
                style={{
                  borderLeft: "1px solid #EAEAEA",
                  borderTop: "1px solid #EAEAEA",
                  borderBottom: "1px solid #EAEAEA",
                  borderRight: "0",
                  background: "#fff",
                  padding: "0 0 0 0.8rem",
                  cursor: "pointer",
                  borderRadius: "6px 0 0 6px",
                  fontSize: "10px",
                }}
              >
                Rp.
              </button>
            </InputTextMaster>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.disabled}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  );
}
